import {Helmet} from "react-helmet-async";
import {Navigate} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {METRICS_EXPLORER} from "@/lib/featureFlags.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {MetricsExplorerContent} from "@/pages/metricsExplorer/MetricsExplorerContent.tsx";

export const MetricsExplorerPage = () => {
  const {userHasFeature} = useCurrentUserContext();

  if (!userHasFeature(METRICS_EXPLORER)) {
    return <Navigate to="/access-denied" />;
  }

  return (
    <>
      <Helmet>
        <title>Metrics Explorer</title>
      </Helmet>
      <ContentContainer title="Metrics Explorer">
        <UpErrorBoundary>
          <MetricsExplorerContent />
        </UpErrorBoundary>
      </ContentContainer>
    </>
  );
};
